import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {TicketSetBuyResultVo} from '../../common/shared/api/nicolas/vo/TicketSetBuyResultVo.interface';

/**
 * 세트상품 구매
 *
 * Origin: pageNicolasApi.postTicketSetBuy
 * API: POST /api/v1/ticket/set_buy
 */
export async function postTicketSetBuy(
  {
    setId,
    seriesId,
    ticketId,
  }: {
    setId: number;
    seriesId: number;
    ticketId: string;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: TicketSetBuyResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/set_buy',
    {
      method: 'POST',
      data: {
        set_id: setId,
        series_id: seriesId,
        ticket_id: ticketId,
      },
    },
    options
  );
  return response.data;
}
